import { createApp } from 'vue'
import App from './App.vue'

// Import Vuetify
import 'vuetify/styles';
import { createVuetify } from 'vuetify';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';
const vuetify = createVuetify({
  components,
  directives,
});

const vueApp = createApp(App);
vueApp.use(vuetify);
vueApp.mount('#app');
